module.exports = __webpack_public_path__ + "media/dbass.408dc5a7.ogg";